import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Rule } from "./../../../../models/Rule";
import { Component, OnInit } from "@angular/core";
import { PortefeuilleDetail } from "src/app/fonds-propres/models/PortefeuilleDetail";
import { FondsPropresService } from "src/app/fonds-propres/services/fonds-propres.service";
import { Garantie } from "src/app/fonds-propres/models/Garantie";

@Component({
  selector: "app-item-credit",
  templateUrl: "./item-credit.component.html",
  styleUrls: ["./item-credit.component.scss"],
})
export class ItemCreditComponent implements OnInit {
  constructor(
    private shared: FondsPropresService,
    private activeModal: NgbActiveModal
  ) {}

  //From Modal:  parameters
  portefeuilleDetail: PortefeuilleDetail;

  //From DB
  rules: Rule[] = [];
  garanties: Garantie[] = [];

  ngOnInit() {
    this.getSegmentRules(this.portefeuilleDetail.id);
    this.garanties = this.portefeuilleDetail.garanties;
  }

  getSegmentRules(portefeuilleDetailId: number) {
    this.shared.getSegmentRules(portefeuilleDetailId).subscribe(
      (data) => {
        this.rules = data;
      },
      (error) => {
        console.log(error);
      },
      () => {
        if (this.rules == null) {
          this.rules = [];
        }
      }
    );
  }
}
